// src/components/PWA/InstallPrompt.jsx
import React, { useState, useEffect } from 'react';
import './InstallPrompt.css';

const InstallPrompt = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showPrompt, setShowPrompt] = useState(false);
    const [isIOS, setIsIOS] = useState(false);
    const [showIOSInstructions, setShowIOSInstructions] = useState(false);

    useEffect(() => {
        // Check if already installed
        if (window.matchMedia('(display-mode: standalone)').matches) {
            return;
        }

        // Check if dismissed
        const dismissed = localStorage.getItem('pwa-install-dismissed');
        if (dismissed) {
            return;
        }

        // Detect iOS
        const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        setIsIOS(iOS);

        if (iOS) {
            // Show iOS prompt after 3 seconds
            setTimeout(() => setShowPrompt(true), 3000);
        } else {
            // Listen for beforeinstallprompt event (Android/Desktop)
            const handler = (e) => {
                e.preventDefault();
                setDeferredPrompt(e);
                setShowPrompt(true);
            };

            window.addEventListener('beforeinstallprompt', handler);

            return () => window.removeEventListener('beforeinstallprompt', handler);
        }
    }, []);

    const handleInstall = async () => {
        if (!deferredPrompt) return;

        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;

        if (outcome === 'accepted') {
            console.log('PWA installed');
        }

        setDeferredPrompt(null);
        setShowPrompt(false);
    };

    const handleDismiss = () => {
        setShowPrompt(false);
        localStorage.setItem('pwa-install-dismissed', 'true');
    };

    const showIOSModal = () => {
        setShowIOSInstructions(true);
    };

    if (!showPrompt) return null;

    return (
        <>
            {/* Install Banner */}
            <div className="install-prompt">
                <div className="install-content">
                    <div className="install-icon">📱</div>
                    <div className="install-text">
                        <h4>Install ZeroPing</h4>
                        <p>Get the app experience on your device</p>
                    </div>
                </div>
                <div className="install-actions">
                    {isIOS ? (
                        <button className="install-btn" onClick={showIOSModal}>
                            Install
                        </button>
                    ) : (
                        <button className="install-btn" onClick={handleInstall}>
                            Install
                        </button>
                    )}
                    <button className="dismiss-btn" onClick={handleDismiss}>
                        ✕
                    </button>
                </div>
            </div>

            {/* iOS Instructions Modal */}
            {showIOSInstructions && (
                <div className="ios-modal-overlay" onClick={() => setShowIOSInstructions(false)}>
                    <div className="ios-modal" onClick={(e) => e.stopPropagation()}>
                        <h3>Install ZeroPing on iOS</h3>
                        <div className="ios-steps">
                            <div className="ios-step">
                                <span className="step-number">1</span>
                                <p>Tap the <strong>Share</strong> button <span className="ios-icon">⎋</span></p>
                            </div>
                            <div className="ios-step">
                                <span className="step-number">2</span>
                                <p>Scroll down and tap <strong>"Add to Home Screen"</strong> <span className="ios-icon">➕</span></p>
                            </div>
                            <div className="ios-step">
                                <span className="step-number">3</span>
                                <p>Tap <strong>"Add"</strong> in the top right corner</p>
                            </div>
                        </div>
                        <button className="ios-close-btn" onClick={() => setShowIOSInstructions(false)}>
                            Got it!
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default InstallPrompt;
